import { render, staticRenderFns } from "./UModal.vue?vue&type=template&id=05e77062&scoped=true"
import script from "./UModal.vue?vue&type=script&lang=js"
export * from "./UModal.vue?vue&type=script&lang=js"
import style0 from "./UModal.vue?vue&type=style&index=0&id=05e77062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e77062",
  null
  
)

export default component.exports